<template>
  <div class="d-inline-block">
    <div id="tooltip-recipient">
      <Button
        class="btn btn-color1"
        :class="parsedBtnClasses"
        :disabled="!isNewOrderAvailable"
        @click="openNewOrderModal"
      >
        {{ $t('include_budget') }}
      </Button>
      <template v-if="!isNewOrderAvailable">
        <b-tooltip custom-class="font-size-xSmall" target="tooltip-recipient" triggers="hover">
          <p class="mb-0">{{ newOrderTooltipText }}</p>
        </b-tooltip>
      </template>
      <template v-if="user">
        <CreateOrderModal
          :company="user.company"
          :advertiser="advertiser"
          :reloadAdvertisers="reloadAdvertisers"
          @order-created="handleOrderCreated"
        />
        <EditCompanyModal
          :company="user.company"
          @company-updated="handleCompanyUpdated"
        />
      </template>
    </div>
  </div>
</template>

<script>

import UsersService from '@/v1/modules/users/services/users-service'
import { mapState } from 'vuex'

import Button from '@/v1/components/common/Button/Button.vue'
import CreateOrderModal from '@/v1/components/orders/CreateOrderModal.vue'
import EditCompanyModal from '@/v1/components/companies/EditCompanyModal.vue'

export default {
  name: 'CreateOrderButton',
  props: ['advertiser', 'reloadAdvertisers', 'btnClasses'],
  components: {
    Button,
    CreateOrderModal,
    EditCompanyModal
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    /**
     * Return if company is advertiser
     */
    isAdvertiser () {
      return this.user && this.user.company.type === 'ADVERTISER'
    },
    /**
     * Return if new order button should be available
     */
    isNewOrderAvailable () {
      if (!this.user) return false
      if (this.isAdvertiser) return true
      if (!this.user.company.recipient_status && (this.user.role.slug !== 'user-manager' && this.user.role.slug !== 'administrator')) return false
      return true
    },
    /**
     * Text for the tooltip when new order button is disabled
     */
    newOrderTooltipText () {
      if (!this.user) return ''
      if (!this.user.company.recipient_status && (this.user.role.slug !== 'user-manager' && this.user.role.slug !== 'administrator')) return this.$t('alert_include_budget')
      return ''
    },
    parsedBtnClasses () {
      return this.btnClasses ? this.btnClasses : ''
    }
  },
  methods: {
    /**
     * Handle company updated
     */
    async handleCompanyUpdated () {
      await UsersService.me()
    },
    /**
     * Handle order created
     */
    handleOrderCreated (order) {
      this.$emit('order-created', order)
    },
    /**
     * Handle recipient created
     */
    async handleRecipientCreated () {
      await UsersService.me()
      this.$emit('recipient-created')
    },
    /**
     * Open new order modal
     */
    openNewOrderModal () {
      if (!this.user) return

      if (!this.user.company.is_complete) {
        this.$bvModal.show('edit-company-modal')
        return
      }

      this.$bvModal.show('create-order-modal')
    }
  }
}
</script>
